import type { LevelDef } from '../level.ts';

// El Prat: a coastal parallel pair with a third strip converging on it at a
// shallow ~40° (the real 02/20 against 06L/24R). Converging traffic is the
// lesson — two streams that never cross but squeeze into the same corner.
export const barcelona: LevelDef = {
  id: 'barcelona', city: 'barcelona', country: 'spain',
  blurb: 'delta haze, a shore-side pair and one strip converging on it',
  baseline: 350, scoreMul: 1.6,
  capBase: 3, capDiv: 4, capMax: 6,
  spawnLead: [5, 11], minSpawnGap: 1.9, tempo: 1,
  mix: [['light', 0.26], ['medium', 0.30], ['heavy', 0.22], ['jet', 0.22]],
  layout: {
    runways: [
      { x1: -0.70, y1: -0.34, x2: 0.18, y2: -0.70 },
      { x1: -0.62, y1: 0.05, x2: 0.30, y2: -0.33 },
      { x1: -0.05, y1: 0.70, x2: 0.42, y2: -0.14 },
    ],
    pads: [],
  },
  palette: { bg: '#faf4ea', field: '#ecdfc9', deep: '#e2d3b8', water: '#cfe0dd' },
  decor: ['sagrada', 'mosaic'],
  // the Mediterranean in the bottom-right corner, past the delta
  water: [{ x: 0.50, y: 1 }, { x: 0.70, y: 0.87 }, { x: 1, y: 0.76 }, { x: 1, y: 1 }],
  arrivalSides: [0.7, 1, 1.3, 1],
  // e4 major pentatonic: warmest, quickest
  music: { root: 64, mode: 'major pentatonic', bpm: 66, wind: 0.5, verb: 0.45, bright: 3200 },
};
